import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles((theme) => ({
  totalTitleWrapper: {
    color: theme.palette.text.secondary,
    fontSize: 11,
    textTransform: "uppercase",
    textAlign: "end",
  },
  totalValueDivider: {
    width: 16,
    height: 2,
    margin: "0 8px",
    backgroundColor: theme.palette.text.primary,
    opacity: 0.85,
  },
  divider: {
    marginLeft: 20,
    height: "60%",
  },
  handle: {
    position: "absolute",
    left: -24,
    top: 8,
  }
}));

export default useStyle;
